import React from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  Button,
} from '@material-ui/core'
import { useIntl } from 'react-intl'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  dialogActionsStyle: {
    padding: '25px',
    '& button': {
      padding: '10px 40px',
    },
  },
  dialogTitleStyle: {
    '& h2': {
      padding: '15px 10px 0px 15px',
      fontSize: '25px',
      alignItems: 'center',
    },
  },
  contentStyle: {
    textAlign: 'center',
  },
  cancelAction: {
    color: '#404040',
    backgroundColor: '#fff',
  },
  confirmlAction: {
    borderColor: '#f74872',
    backgroundColor: '#f74872',
    color: 'white',
    '&:hover': {
      backgroundColor: '#f74872',
    },
  },
}))

const ConfirmDeleteCustomFieldPopup = ({
  openDeleteCustomField,
  setOpenDeleteCustomField,
  deleteCustomLabel,
}) => {
  const { formatMessage } = useIntl()
  const classes = useStyles()
  const handleTogglePopup = () => {
    setOpenDeleteCustomField(null)
  }
  const handleDeleteCustomLabel = () => {
    deleteCustomLabel()
    handleTogglePopup()
  }
  return (
    <Dialog
      open={openDeleteCustomField}
      onClose={handleTogglePopup}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title" className={classes.dialogTitleStyle}>
        {formatMessage({ id: 'crm.form.delete.custom.filed.popup.title' })}
      </DialogTitle>
      <DialogContent>
        <DialogContentText className={classes.contentStyle}>
          {formatMessage({ id: 'crm.form.delete.custom.field.popup.content' })}
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.dialogActionsStyle}>
        <Button onClick={handleTogglePopup} className={classes.cancelAction}>
          {formatMessage({ id: 'action.cancel' })}
        </Button>
        <Button
          onClick={handleDeleteCustomLabel}
          variant="contained"
          className={classes.confirmlAction}
        >
          {formatMessage({ id: 'action.delete' })}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmDeleteCustomFieldPopup
